<lex-sidenav-container defaultNavSize="540" >
	<ng-container left >
		<lex-case-notes-list></lex-case-notes-list>
	</ng-container>
	<ng-container right>
		<div style="display: flex; flex-direction: column; gap: 20px;">
			<lex-case-notes-editor></lex-case-notes-editor>
		</div>
	</ng-container>
</lex-sidenav-container>
